/**
 * Tipos aceitos como imagem de projeto, iguais aos do `filterImage` da API.
 *
 * O `accept` do <input> só filtra o que o seletor mostra — o usuário troca
 * para "todos os arquivos" e escolhe o que quiser. Por isso a checagem se
 * repete aqui, para o erro aparecer antes do upload em vez de voltar 415.
 */
const ACCEPTED_IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg'];
const ACCEPTED_IMAGE_MIMETYPES = ['image/png', 'image/jpeg'];

/** Valor pronto para o atributo `accept` de um <input type="file">. */
const IMAGE_ACCEPT = ACCEPTED_IMAGE_MIMETYPES.join(',');

function isAcceptedImage(file) {
  const name = (file.name || '').toLowerCase();
  const hasExtension = ACCEPTED_IMAGE_EXTENSIONS.some(ext =>
    name.endsWith(ext)
  );

  return (
    hasExtension &&
    ACCEPTED_IMAGE_MIMETYPES.includes((file.type || '').toLowerCase())
  );
}

export { isAcceptedImage, IMAGE_ACCEPT };
